import { Step1 } from "../../pages/itin/steps/Step1";
import { Step2 } from "../../pages/itin/steps/Step2";
import { Step3 } from "../../pages/itin/steps/Step3";
import { Step4 } from "../../pages/itin/steps/step4";
import { Step } from "../FormStepper";

export const STEPS: Step[] = [
    
  {
    name: "General Subscription Info",
    label: "STEP 1",
    id: "step_a",
    element: <Step1 />,
  },
  {
    name: "Step 2",
    label: "STEP 2",
    id: "step_b",
    element: <Step2 />,
  },
  {
    name: "Step 3",
    label: "STEP 3",
    id: "step_c",
    element: <Step3 />,
  },
  {
    name: "Step 4",
    label: "STEP 4",
    id: "step_d",
    element: <Step4 />,
  },
];
